export default new VueRouter({
    routes: [{
        path: '/',
        name: '',
        meta: {
            title: '天瑞集团'
        }
    }]
})
